export default __webpack_public_path__ + "static/media/undraw_fixing_bugs_w7gi.d713f9d4.svg";